<script setup lang="ts">
    import { ref, toRef } from 'vue'
    import ContentCollapse from '@/js/components/Common/ContentCollapse.vue'
    import ChartBox from '@/js/components/Chart/ChartBox.vue'
    import { useSemester } from '@/js/composables/useSemester'
    import type { Kennzahl, DashboardValue } from '@/js/composables/chart/types'

    const props = defineProps<{
        dashboardData: DashboardValue[]
        yearsToDisplay: number
    }>()

    const { dashboardDataYears } = useSemester(toRef(props, 'dashboardData'), toRef(props, 'yearsToDisplay'))

    const kennzahlen = ref<Kennzahl[]>([
        {
            kennzahlId: '2.1.',
            kennzahlTitle: 'Anzahl aller Immatrikulierter im Studiengang',
            types: ['BarChartStacked', 'LineChart'],
            dataStrategy: 'stacked',
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl Immatrikulierter',
            datasetLabels: ['Immaquote', 'weiblich', 'männlich']
        },
        {
            kennzahlId: '2.2.',
            kennzahlTitle: 'Anzahl deutscher Immatrikulierter (nach Bundesland)',
            // wert ist eine kommaseparierte Bundesland-Liste (z. B. "Bayern,Bayern,Sachsen")
            // — Frequenz pro Bundesland ergibt den Y-Wert. Eine Linie je Bundesland;
            // Bundesländer kommen aus den Daten, alphabetisch sortiert; fehlt ein
            // Bundesland in einem Semester, wird die Linie unterbrochen.
            types: ['LineChart'],
            dataStrategy: 'bundesland',
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl deutscher Immatrikulierter',
            showLegend: true
        },
        {
            kennzahlId: '2.3.',
            kennzahlTitle: 'Anzahl deutscher Immatrikulierter (nach HZB)',
            types: ['BarChart', 'LineChart'],
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl Neueinschreiber'
        }
    ])
</script>

<template>
    <ContentCollapse collapse-key="collapse-dashboard-ziel-2" title="2. Studierendenstatistik" is-visible-by-default>
        <div class="d-flex flex-wrap p-4 justify-space-between ga-1">
            <ChartBox
                v-for="(kennzahl, key) in kennzahlen"
                :key="kennzahl.kennzahlId"
                :kennzahl="kennzahl"
                :dashboard-data="dashboardData"
                :dashboard-data-years="dashboardDataYears"
                storage-key=""
                :box-size="350"
                :show-title="true"
                :show-target-value="false"
                :center-box="kennzahlen.length === 2 && key === 1"
            />
        </div>
    </ContentCollapse>
</template>

<style scoped></style>
